import Vue from 'vue';
import MobileNumber from '../pc/components/MobileNumber.vue';
// import Navbar from "../html5/components/Navbar";
// import BottomArea from "../html5/components/BottomArea";

import BdoSelect from "../pc/components/BdoSelect";
import LandlineNumber from "../pc/components/LandlineNumber";
import ProvinceSelect from "../pc/components/ProvinceSelect";
import CityAndZipCode from "../pc/components/CityAndZipCode";
import BusinessNatrue from "../pc/components/BusinessNatrue";
import BusinessDescrption from "../pc/components/BusinessDescrption";
//PC
import Steps from "../pc/components/Steps";
import BdoProgress from "../pc/components/BdoProgress";
import FormTitle from "../pc/components/FormTitle";
import BottomButton from "../pc/components/BottomButton";
import BdoRadios from "../pc/components/BdoRadios";
import SideBar from "../pc/components/SideBar";
import PageContent from "../pc/components/PageContent";
import StepsV2 from "../pc/components/StepsV2";
import PanelV2 from "../pc/components/PanelV2";
import Requirements from "../pc/components/Requirements";
import NewPassword from "../pc/components/NewPassword";
import AccountType from "../pc/components/AccountType";
import InfoBox from "../pc/components/InfoBox";
import BdoMerchantId from "../pc/components/BdoMerchantId";
import ConfirmPassword from "../pc/components/ConfirmPassword";
import SelectDate from "../pc/components/SelectDate";

Vue.component('MobileNumber', MobileNumber);
Vue.component('Navbar', {template: '<div></div>'});
Vue.component('BottomArea', {template: '<div></div>'});
Vue.component('BdoRadios', BdoRadios);
Vue.component('BdoSelect', BdoSelect);
Vue.component('LandlineNumber', LandlineNumber);
Vue.component('ProvinceSelect', ProvinceSelect);
Vue.component('CityAndZipCode', CityAndZipCode);
Vue.component('BusinessNatrue', BusinessNatrue);
Vue.component('BusinessDescrption', BusinessDescrption);
Vue.component('BottomButton', BottomButton);

Vue.component('Steps', Steps);
Vue.component('BdoProgress', BdoProgress);
Vue.component('FormTitle', FormTitle);
Vue.component('SideBar', SideBar);
Vue.component('PageContent', PageContent);
Vue.component('StepsV2', StepsV2);
Vue.component('PanelV2', PanelV2);
Vue.component('Requirements', Requirements);
Vue.component('NewPassword', NewPassword);
Vue.component('AccountType', AccountType);
Vue.component('InfoBox', InfoBox);
Vue.component('BdoMerchantId', BdoMerchantId);
Vue.component('ConfirmPassword', ConfirmPassword);
Vue.component('SelectDate', SelectDate);
